import * as yup from 'yup';
import { withFormik } from "formik";
import { TelephonyDeploymentFormData } from './TelephonyDeploymentFormData';
import TelephonyDeployment from './TelephonyDeployment';
import TelephonyDeploymentRequest from '../../../../models/telephonyDeployment/TelephonyDeploymentRequest';
import { TelephonyDeploymentResponse } from '../../../../models/telephonyDeployment/TelephonyDeploymentResponse';
import ApplicationContainer from '../../../../state/containers/ApplicationContainer';
import { GoogleTTSVoice } from './TelephonyDeploymentFormFieldOptions';

export interface TelephonyDeploymentProps {
    closeTelephonyRequestForm: () => void;
    submitTelephonyDeployment: (request: TelephonyDeploymentRequest, phoneNumber?: string) => void;
    environmentId: string;
    selectedTelephonyDeployment: TelephonyDeploymentResponse;
    appContainer: ApplicationContainer;
    formatPhoneNumber: (phoneNumber: string) => void;
}

const TelephonyDeploymentForm = withFormik<TelephonyDeploymentProps, TelephonyDeploymentFormData>({
    mapPropsToValues: (props) => ({
        noTracking: props.selectedTelephonyDeployment?.noTracking ?? false,
        phoneNumberStartsWith: props.selectedTelephonyDeployment?.phoneNumber ? props.selectedTelephonyDeployment?.phoneNumber : "",
        ttsVoice: props.selectedTelephonyDeployment?.ttsVoice as GoogleTTSVoice ?? "en-US-Neural2-G" as GoogleTTSVoice,
        locale: props.selectedTelephonyDeployment?.locale ? props.selectedTelephonyDeployment?.locale : props.appContainer?.state?.currentApp?.languages[0]?.shortCode ? props.appContainer?.state?.currentApp?.languages[0]?.shortCode : "en-US",
        asrEndpointing: props.selectedTelephonyDeployment?.asrEndpointing ?? 50,
        asrModel: props.selectedTelephonyDeployment?.asrModel ?? "nova-2",
        asrTier: props.selectedTelephonyDeployment?.asrTier ?? "",
        firstMessageDelayMS: props.selectedTelephonyDeployment?.firstMessageDelayMS ?? 0,
        mergeTurnsAfterPauses: props.selectedTelephonyDeployment?.mergeTurnsAfterPauses ?? false,
        mergeTurnTimeoutMS: props.selectedTelephonyDeployment?.mergeTurnTimeoutMS ?? 2000,
        disableBargeIn: props.selectedTelephonyDeployment?.disableBargeIn ?? false,
        repromptAttempts: props.selectedTelephonyDeployment?.repromptAttempts ?? 2,
        repromptDelaySeconds: props.selectedTelephonyDeployment?.repromptDelaySeconds ?? 10,
        name: props.selectedTelephonyDeployment?.name ?? "",
        ttsProvider: props.selectedTelephonyDeployment?.ttsProvider ?? "Google",
        proactiveResponseDelayMS: props.selectedTelephonyDeployment?.proactiveResponseDelayMS ?? 1500,
        proactiveResponses: props.selectedTelephonyDeployment?.proactiveResponses ?? "One moment|Let's see|Just a moment|Hold on a sec|Hang on while I get that|Give me a moment",
        useProactiveResponses: props.selectedTelephonyDeployment?.useProactiveResponses ?? true,
        disableWelcomeMessageBargeIn: props.selectedTelephonyDeployment?.disableWelcomeMessageBargeIn ?? true,
        disableSpeechStarted: props.selectedTelephonyDeployment?.disableSpeechStarted ?? false,
        speechStartedUnconfirmedBargeInLimit: props.selectedTelephonyDeployment?.speechStartedUnconfirmedBargeInLimit ?? 3,
        speechStartedPauseMS: props.selectedTelephonyDeployment?.speechStartedPauseMS ?? 1000,
        speechStartedRequiredBufferCount: props.selectedTelephonyDeployment?.speechStartedRequiredBufferCount ?? 7,
    }),
    validationSchema: yup.object().shape({
        asrEndpointing: yup.number().min(0, "Must be a number more than 0"),
        firstMessageDelayMS: yup.number().min(0, "Must be a number more than 0"),
        mergeTurnTimeoutMS: yup.number().min(0, "Must be a number more than 0"),
        repromptAttempts: yup.number().min(0, "Must be a number more than 0"),
        repromptDelaySeconds: yup.number().min(0, "Must be a number more than 0")
    }),
    handleSubmit: async (values, { props, setSubmitting }) => {
        const telephonyRequest: TelephonyDeploymentRequest = {
            ...props.selectedTelephonyDeployment,
            noTracking: values.noTracking,
            phoneNumberStartsWith: values.phoneNumberStartsWith,
            environmentId: props.environmentId,
            ttsProvider: values.ttsProvider ?? "Google",
            ttsVoice: values.ttsVoice,
            locale: values.locale,
            asrEndpointing: values.asrEndpointing,
            asrModel: values.asrModel,
            asrTier: values.asrTier,
            firstMessageDelayMS: values.firstMessageDelayMS,
            mergeTurnsAfterPauses: values.mergeTurnsAfterPauses,
            mergeTurnTimeoutMS: values.mergeTurnTimeoutMS,
            disableBargeIn: values.disableBargeIn,
            repromptAttempts: values.repromptAttempts,
            repromptDelaySeconds: values.repromptDelaySeconds,
            name: values.name,
            proactiveResponseDelayMS: values.proactiveResponseDelayMS,
            proactiveResponses: values.proactiveResponses,
            useProactiveResponses: values.useProactiveResponses,
            disableWelcomeMessageBargeIn: values.disableWelcomeMessageBargeIn,
            disableSpeechStarted: values.disableSpeechStarted,
            speechStartedUnconfirmedBargeInLimit: values.speechStartedUnconfirmedBargeInLimit,
            speechStartedPauseMS: values.speechStartedPauseMS,
            speechStartedRequiredBufferCount: values.speechStartedRequiredBufferCount
        };

        setSubmitting(true);
        props.submitTelephonyDeployment(telephonyRequest);
        setSubmitting(false)
        props.closeTelephonyRequestForm();
    }
})(TelephonyDeployment);

export default TelephonyDeploymentForm;